<script lang="ts" setup>
import type { OperationModel } from "~/core/models/OperationModel.interface";
import type { OperationModelType } from "~/core/models/OperationModelType.enum";
import type DtwinFormOperationList from "~/modules/dtwin/components/DtwinFormOperationList.vue";
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import type { DtwinFormOperationListColumnConfig } from "~/modules/dtwin/models/DtwinFormOperationListColumnConfig.type";
import { DtwinFormOperationListColumns } from "~/modules/dtwin/models/DtwinFormOperationListColumns.enum";
import type { DtwinModel } from "~/modules/dtwin/models/DtwinModel.interface";
import { LicenseFeatureName } from "~/modules/license/models/LicenseFeatureName.enum";
import { useLicenseStore } from "~/modules/license/stores/useLicenseStore";

defineProps<{
  organizationCode: number;
  dtwin: Dtwin;
  dtwinModel: DtwinModel;
  dtwinOperationModel: OperationModel;
  operationType: OperationModelType;
  reload?: boolean;
  columns: DtwinFormOperationListColumnConfig[];
}>();

const emit = defineEmits(["edit"]);

const licenseStore = useLicenseStore();
const { t } = useI18n();

const baseComponentRef = ref<
  (ComponentPublicInstance & { reload: () => Promise<void> | void }) | undefined
>();

function reloadWithContext() {
  baseComponentRef.value?.reload();
}

function onEdit(operation: unknown) {
  emit("edit", operation);
}
defineExpose({
  reload: reloadWithContext,
});
</script>

<template>
  <lxc-tabs>
    <lxc-tab-pane :label="t('operation.unitary.title')">
      <dtwin-form-operation-list
        ref="baseComponentRef"
        :organization-code="organizationCode"
        :dtwin="dtwin"
        :dtwin-model="dtwinModel"
        :dtwin-operation-model="dtwinOperationModel"
        :operation-type="operationType"
        :reload="reload"
        show-custom-column
        :created-in-campaign="'false'"
        :columns="[...columns, DtwinFormOperationListColumns.ACTION]"
        @edit="onEdit"
      >
        <template v-for="(_, name) in $slots" #[name]="slotData">
          <slot :name="name" v-bind="slotData" />
        </template>
      </dtwin-form-operation-list>
    </lxc-tab-pane>
    <lxc-tab-pane
      v-if="
        licenseStore.isLicenseFeatureEnabled(
          LicenseFeatureName.CAMPAIGN_MANAGEMENT_STATIC,
        )
      "
      :label="t('operation.campaign.title')"
    >
      <dtwin-form-operation-list
        :organization-code="organizationCode"
        :dtwin="dtwin"
        :dtwin-model="dtwinModel"
        :dtwin-operation-model="dtwinOperationModel"
        :operation-type="operationType"
        :reload="reload"
        show-custom-column
        :created-in-campaign="'true'"
        :columns="[...columns, DtwinFormOperationListColumns.TRIGGER]"
      >
        <template v-for="(_, name) in $slots" #[name]="slotData">
          <slot :name="name" v-bind="slotData" />
        </template>
      </dtwin-form-operation-list>
    </lxc-tab-pane>
  </lxc-tabs>
</template>
